<template>
  <v-layout row justify-center>
    <v-dialog v-model="$store.state.moreBtnStore.moreBtnOtherTuneModal" width="400px">
      <v-card>
        <v-card-title class="headline">その他の曲使用</v-card-title>
        <v-card-text>
          <p class="red--text" v-show="!$store.state.customerInfo.other_song_bring_flg">※ 原盤を会場へ必ずお持ち込み願います</p>
          <p>
            その他で使用されたい曲がある場合、その曲のタイトルとアーティスト名をご入力ください。<br>
            記録ビデオを注文の際は、フリーBGMに挿し替わります。
          </p>
          <v-text-field
            name="oher_song_name"
            label="楽曲"
            v-model="otherSongName"
            single-line
          ></v-text-field>
          <v-text-field
            name="oher_song_name"
            label="アーティスト名"
            v-model="otherSongArtistName"
            single-line
          ></v-text-field>
        </v-card-text>
        <v-layout row wrap class="more-btn-other-tune-modal__error-message-container">
          <v-flex xs12 v-show="isNotExistDuplicationOtherTuneFlag === false"
                  class="warn-text">プレイリストに重複するその他の楽曲が存在しています。</v-flex>
          <v-flex xs12 v-if="canNotAddSong" class="error-text">使用できる回数の上限に達しているため追加出来ません。</v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="cancel">キャンセル</v-btn>
          <v-btn color="green darken-1"
                 flat="flat"
                 :disabled="!otherTuneFormIsValid || canNotAddSong" @click="addOtherTune()">追加</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import CustomerPlayListService from '@/components/services/CustomerPlayListService.vue'
import OtherTuneService from '@/components/services/OtherTuneService.vue'
export default {
  name: 'MoreBtnOtherTuneModal',
  data () {
    return {
      users: {
        other_song_limit: 10
      },
      customerPlaylistProductId: null,
      isNotExistDuplicationOtherTuneFlag: true,
      itemIndex: null,
      playListType: null,
      otherSongName: null,
      otherSongArtistName: null,
      othersDialog: false
    }
  },
  computed: {
    canNotAddSong () {
      if (this.hasOtherTune()) return false
      if (this.$store.getters.getOtherSongLimit) {
        return this.$store.getters.getOtherTuneInPlayListCount >= this.$store.getters.getOtherSongLimit
      } else {
        return false
      }
    },
    otherTuneFormIsValid () {
      return (
        this.otherSongName &&
        this.otherSongArtistName
      )
    }
  },
  mounted () {
    this.setOtherTuneParam()
    this.changeOtherTune()
  },
  watch: {
    otherSongName (val) {
      this.changeOtherTune()
    },
    otherSongArtistName () {
      this.changeOtherTune()
    }
  },
  methods: {
    setOtherTuneParam () {
      let modalParam = this.$store.getters.getMoreBtnModalParam
      this.customerPlaylistProductId = modalParam.moreBtnCustomerPlaylistProductId
      this.itemIndex = modalParam.moreBtnItemIndex
      this.playListType = modalParam.moreBtnPlayListType
      let otherTune = this.$store.getters.getOtherTuneInfo(modalParam.moreBtnPlayListType, modalParam.moreBtnItemIndex)
      if (otherTune) {
        this.otherSongName = otherTune.otherSongName ? otherTune.otherSongName : null
        this.otherSongArtistName = otherTune.otherArtistName ? otherTune.otherArtistName : null
      }
    },
    /**
     * その他の楽曲が修正される場合
     **/
    changeOtherTune () {
      if (!(this.otherSongName && this.otherSongArtistName)) return
      OtherTuneService.isNotExistDuplicationOtherTune(this.otherSongName, this.otherSongArtistName, this.playListType, this.itemIndex, (response) => {
        this.isNotExistDuplicationOtherTuneFlag = response
      })
    },
    addOthers: function () {
      this.othersDialog = true
    },
    /**
     * その他の楽曲を追加
     **/
    addOtherTune () {
      let transactionId = this.$store.state.transactionId
      let formData = new URLSearchParams()
      formData.append('product_id', this.getOtherProductId())
      formData.append('customer_playlist_product_id', this.customerPlaylistProductId)
      formData.append('isum_code', ' ')
      formData.append('isum_type', ' ')
      formData.append('isum_song_name', ' ')
      formData.append('isum_artist_name', ' ')
      formData.append('other_song_name', this.otherSongName)
      formData.append('other_artist_name', this.otherSongArtistName)
      formData.append('transactionid', transactionId)
      CustomerPlayListService.updatePlayListTune(formData, (response) => {
        this.$store.dispatch('switchMoreBtnOtherTuneModalFlag', false)
        CustomerPlayListService.findCustomerPlayList(this.playListType, transactionId, (response) => {
        }, (error) => {
          this.$log.error(error)
        })
      }, (error) => {
        this.$log.debug(error)
      })
    },
    cancel () {
      this.$store.dispatch('switchMoreBtnOtherTuneModalFlag', false)
    },
    hasOtherTune () {
      let result = false
      if (this.$store.getters.getOtherTuneByPlayListIdAndIndex(this.playListType, this.itemIndex)) {
        result = true
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
.more-btn-other-tune-modal__error-message-container{
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/MoreBtnOtherTuneModal.vue